/**
 * Home view — reuses the shared ConversationsTable in compact mode.
 */

import { useCallback } from 'react';
import { toast } from 'sonner';
import { useAuth } from '@/client/app/providers/auth-context';
import { useUserRole } from '@/client/app/providers/RuntimeProvider';
import { ConversationsTable } from '@/client/components/conversations/ConversationsTable';

interface ConversationsViewProps {
  onSelectThread: (threadId: string) => void;
}

export function ConversationsView({ onSelectThread }: ConversationsViewProps) {
  const { userEmail, userName } = useAuth();
  const userRole = useUserRole();
  const isAdmin = userRole === 'admin';
  const handleCopyThreadId = useCallback((threadId: string) => {
    navigator.clipboard.writeText(threadId);
    toast.success('Thread ID copied to clipboard');
  }, []);

  const handleRowClick = useCallback(
    (threadId: string) => {
      onSelectThread(threadId);
    },
    [onSelectThread],
  );

  return (
    <ConversationsTable
      onRowClick={handleRowClick}
      isAdmin={isAdmin}
      currentUserEmail={userEmail ?? ''}
      currentUserName={userName ?? undefined}
      onCopyThreadId={handleCopyThreadId}
      compact
    />
  );
}
